function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBuildings = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none"
    },
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#868686"
    },
    d: "M12,5.89V1H0V23H24V5.89ZM4.8,20.56H2.4V18.11H4.8Zm0-4.89H2.4V13.22H4.8Zm0-4.89H2.4V8.33H4.8Zm0-4.89H2.4V3.44H4.8ZM9.6,20.56H7.2V18.11H9.6Zm0-4.89H7.2V13.22H9.6Zm0-4.89H7.2V8.33H9.6Zm0-4.89H7.2V3.44H9.6Zm12,14.67H12V18.11h2.4V15.67H12V13.22h2.4V10.78H12V8.33h9.6Zm-2.4-9.78H16.8v2.44h2.4Zm0,4.89H16.8v2.44h2.4Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBuildings, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/buildings.8844d49a.svg";
export { ForwardRef as ReactComponent };